import { FC } from 'react';
import { format, parseISO } from 'date-fns';
import { articlePublishedTimeWrapperStyle } from './ArticlePublishedTime.styles.css';

import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';

type Props = {
    dateTime?: string;
};

const ArticlePublishedTime: FC<React.PropsWithChildren<Props>> = ({
    dateTime
}) => {
    if (!dateTime) {
        return null;
    }

    return (
        <time
            className={`${articlePublishedTimeWrapperStyle} ${fontGroups.ladle}`}
            dateTime={dateTime}
        >
            {format(parseISO(dateTime), 'dd MMMM yyyy')}
        </time>
    );
};

export default ArticlePublishedTime;
